import { FocusEvent, MouseEvent } from 'react'

import { TPopupHorizontal, TPopupVertical } from './position'

export interface IPopupContentData {
  direction: {
    horizontal: TPopupHorizontal
    vertical: TPopupVertical
  }
  startPosition: {
    horizontal: TPopupHorizontal
    vertical: TPopupVertical
  }
  action: {
    close: () => void
    focus: () => void
  }
}

export const enum TVisibilityTrigger {
  Click = 'click',
  Hover = 'hover',
  ClickHover = 'click|hover',
  Custom = 'custom',
}

export interface IEventCallback {
  onOpen?: () => void
  onClose?: () => void
}

export interface IPopupMethods {
  close: () => void
  open: () => void
  rootWidth: number
}
